import type { PullWalletFromCloudParams, WalletTransferInfo } from '../sdk/types';
import { AbstractApi } from './Api';

export class WalletApi extends AbstractApi {
  addWalletTransfer({
    chat_id,
    cli_msg_id,
    chain_id,
    chain_type,
    transfer_id,
    status,
  }: WalletTransferInfo) {
    return this.client.invoke('addWalletTransfer', [
      chat_id,
      cli_msg_id,
      chain_id,
      chain_type,
      transfer_id,
      status,
    ]);
  }
  updateWalletTransferStatus(
    transfer_id: WalletTransferInfo['transfer_id'],
    status: WalletTransferInfo['status']
  ) {
    return this.client.invoke('updateWalletTransferStatus', [transfer_id, status]);
  }
  getWalletTransfersByStatus(status: WalletTransferInfo['status']) {
    return this.client.invoke('getWalletTransfersByStatus', [status]);
  }
  getWalletTransferByTransferId(transfer_id: WalletTransferInfo['transfer_id']) {
    return this.client.invoke('getWalletTransferByTransferId', [transfer_id]);
  }
  deleteWalletTransferByTransferId(transfer_id: WalletTransferInfo['transfer_id']) {
    return this.client.invoke('deleteWalletTransferByTransferId', [transfer_id]);
  }
  pullWalletFromCloud({ cloud_data, local_data, local_device }: PullWalletFromCloudParams) {
    return this.client.invoke('pullWalletFromCloud', [cloud_data, local_data, local_device]);
  }
  pullWalletFromCloudV2({ cloud_data, local_data, local_device }: PullWalletFromCloudParams) {
    return this.client.invoke('pullWalletFromCloudV2', [cloud_data, local_data, local_device]);
  }
  setCloudWalletVersion({ edited_version }: { edited_version: number }) {
    return this.client.invoke('setCloudWalletVersion', [edited_version]);
  }
}
